import * as yup from 'yup';
import { gstCheck } from '../../common/regex';

export const validationSchema = yup.object().shape({
  gstNumber: yup
    .string()
    .matches(
      gstCheck,
      'Invalid GST number format'
    ) // Matches GST format
    .required('GST number is required'),
});
